import _ from 'lodash'

const self={
	CDN_ADDRESS: '',
	IMG_ADDRESS: ''
};

_.extend(self,{
	'DEFAULT': {
		'LOGO': '',
		'BLANK': require('@/icons/blank.gif'),
		'IMAGE': require('@/icons/blank.gif'),
		'IMAGE_BLANK': require('@/icons/blank.gif')
	},
	'SITE_ADDRESS': "",
	// 状态
	'STATUS': {
		"NO_NETWORK": ["网络请求失败，请稍后再试！"],
		"NOT_FOUND": ["没有找到此网页！"],
		"NOT_AUTHED": ["您无权访问此页面！"],
		"LOGIN_STATUS_INVALID": ["登录状态失效，请重新登录！"]
	},
	// 错误
	'ERROR': {
		"400": "发生错误",
		"404": "没有找到此网页",
		"500": "服务器发生错误",
		"603": "您输入了非法字符，请检查修改后再操作！"
	}
});

export default self;
